import { DateTime } from 'luxon'

import { Account } from '@/core/api/entities/account/account'

import { Group } from '@core/api/entities/group'

import { Advert } from './advert'

export class Campaign {
	public id: number
	public accountId: number
	public name: string
	public rrule: string
	public rruleType: string
	public exdate: string[]
	public type: string
	public priority: boolean
	public createdAt: DateTime

	public adverts: Advert[]
	public account?: Account
	public groups: Group[]

	constructor(data: {
		id: number
		accountId: number
		name: string
		rrule: string
		rruleType: string
		exdate: string[]
		type: string
		priority: boolean
		createdAt: DateTime
		adverts: Advert[]
		account?: Account
		groups: Group[]
	}) {
		this.id = data.id
		this.accountId = data.accountId
		this.name = data.name
		this.rrule = data.rrule
		this.rruleType = data.rruleType
		this.exdate = data.exdate
		this.type = data.type
		this.priority = data.priority
		this.createdAt = data.createdAt

		this.adverts = data.adverts
		this.account = data.account
		this.groups = data.groups
	}

	static create(data: Partial<Campaign>): Campaign {
		const defaultData = {
			id: 0,
			accountId: 0,
			name: '',
			rrule: '',
			rruleType: '',
			exdate: [],
			type: '',
			priority: false,
			createdAt: DateTime.now(),
			adverts: [],
			account: undefined,
			groups: [],
		}

		return new Campaign({ ...defaultData, ...data })
	}
}
